import { StoreSkill } from '../services/skillStoreService';

export const SKILL_GENERATOR_ID = '00000000-0000-4000-8000-000000000001';

export const isSkillGeneratorSkill = (skill: Pick<StoreSkill, 'id' | 'is_system'>): boolean => (
  skill.is_system && skill.id === SKILL_GENERATOR_ID
);

export const skillStoreCardMode = (
  skill: Pick<StoreSkill, 'id' | 'is_system'>,
): 'skill_builder' | 'operations' => isSkillGeneratorSkill(skill) ? 'skill_builder' : 'operations';

export const skillStoreCardShowsConfiguration = (
  skill: Pick<StoreSkill, 'id' | 'is_system' | 'interaction_type'>,
  isOwner: boolean,
  isAuthenticated: boolean,
): boolean => isAuthenticated
  && skillStoreCardMode(skill) === 'operations'
  && (skill.interaction_type === 'ui' || isOwner);
